export const GROUP_CATEGORY_REQUEST = "GROUP_CATEGORY_REQUEST";
export const GROUP_CATEGORY_RECEIVE = "GROUP_CATEGORY_RECEIVE";
export const GROUP_CATEGORY_FAILURE = "GROUP_CATEGORY_FAILURE";
export const RESET_GROUP_CATEGORY = "RESET_GROUP_CATEGORY";
